import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import {
  setSelectedProcessStatus,
  getSelectedProcessStatus,
} from '../../store/slices/domainOrchestratorPricingCommittee.slice';

const statuses = ['COMPLETED', 'IN_PROGRESS', 'REJECTED', 'RETRIED'];

export const ProcessStatusFilterDropdown = () => {
  const dispatch = useDispatch();
  const selected = useSelector(getSelectedProcessStatus);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(setSelectedProcessStatus(e.target.value));
  };

  return (
    <Form.Select
      data-testid="process-status-filter"
      style={{ fontSize: '14px' }}
      value={selected}
      onChange={handleChange}
    >
      <option value="">Filtrar por status</option>
      {statuses.map(status => (
        <option key={status} value={status}>
          {status}
        </option>
      ))}
    </Form.Select>
  );
};
